import { render, staticRenderFns } from "./ProductsEdit.vue?vue&type=template&id=7e886db2&scoped=true&"
import script from "./ProductsEdit.vue?vue&type=script&lang=js&"
export * from "./ProductsEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductsEdit.vue?vue&type=style&index=0&id=7e886db2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e886db2",
  null
  
)

export default component.exports